import { Popover } from 'antd';
import dayjs from 'dayjs';

const TwoSide = ({
  item2,
  item,
  setMouseHover,
  index2,
}: {
  item2: object;
  item: any;
  setMouseHover: (value: object) => void;
  index2: number;
}) => {
  return (
    <>
      {Array.isArray(item2['start_moment']) &&
      item2['start_moment'][0] === 'morning' ? (
        <div className="is-flex">
          {item2['type_name'][0] === null ? (
            <div
              className="has-text-centered pt-2"
              style={{
                width: '50%',
                height: 40,
                overflow: 'hidden',
                background:
                  item2['status'][0] === 'to_be_approved'
                    ? '#ffef5f'
                    : item2['color'][0] === null
                    ? '#1E87A1'
                    : '',
              }}
            />
          ) : (
            <Popover
              arrow={false}
              content={
                <ul>
                  <li>
                    {dayjs(item2['full_day'])
                      .format('LLLL')
                      .replace('12:00 AM', '')}
                  </li>
                  <li>{item['user_name']}</li>
                  <li>'{item2['type_name'][0]}'</li>
                  <li
                    style={{
                      textTransform: 'capitalize',
                    }}
                  >
                    {item2['start_date']}-{item2['end_date'][0]}(
                    {item2['time_range'][0]}d){' '}
                    {!Array.isArray(item2['status']) &&
                      item2['status'][0]?.replaceAll('_', ' ')}
                  </li>
                </ul>
              }
              placement="bottomLeft"
            >
              <div
                className="has-text-centered pt-2"
                style={{
                  width: '50%',
                  height: 40,
                  background:
                    item2['status'][0] === 'to_be_approved'
                      ? '#ffef5f'
                      : item2['color'][0],
                  color: item2['text_color'][0],

                  overflow: 'hidden',
                }}
                onMouseEnter={() => {
                  setMouseHover({
                    row: index2,
                    column: item?.id,
                  });
                }}
                onMouseLeave={() => {
                  setMouseHover(null);
                }}
              >
                {item2['code'][0]}
              </div>
            </Popover>
          )}
          {item2['type_name'][1] === null ? (
            <div
              className="has-text-centered pt-2"
              style={{
                width: '50%',
                height: 40,
                background:
                  item2['status'][1] === 'to_be_approved'
                    ? '#ffef5f'
                    : item2['color'][1] === null
                    ? '#1E87A1'
                    : '',

                overflow: 'hidden',
              }}
            />
          ) : (
            <Popover
              placement={'bottomLeft'}
              arrow={false}
              content={
                <ul>
                  <li>
                    {dayjs(item2['full_day'])
                      .format('LLLL')
                      .replace('12:00 AM', '')}
                  </li>
                  <li>{item['user_name']}</li>
                  <li>'{item2['type_name'][1]}'</li>
                  <li
                    style={{
                      textTransform: 'capitalize',
                    }}
                  >
                    {item2['start_date']}-{item2['end_date'][1]}(
                    {item2['time_range'][1]}d){' '}
                    {!Array.isArray(item2['status']) &&
                      item2['status'][1]?.replaceAll('_', ' ')}
                  </li>
                </ul>
              }
            >
              <div
                className="has-text-centered pt-2"
                style={{
                  width: '50%',
                  height: 40,
                  background:
                    item2['status'][1] === 'to_be_approved'
                      ? '#ffef5f'
                      : item2['color'][1],
                  color: item2['text_color'][1],
                  overflow: 'hidden',
                }}
                onMouseEnter={() => {
                  setMouseHover({
                    row: index2,
                    column: item?.id,
                  });
                }}
                onMouseLeave={() => {
                  setMouseHover(null);
                }}
              >
                {item2['code'][1]}
              </div>
            </Popover>
          )}
        </div>
      ) : (
        <div className="is-flex">
          {Array.isArray(item2['status']) && (
            <>
              {item2['type_name'][1] === null ? (
                <div
                  className="has-text-centered pt-2"
                  style={{
                    width: '50%',
                    height: 40,
                    background:
                      item2['status'][1] === 'to_be_approved'
                        ? '#ffef5f'
                        : item2['color'][1] === null
                        ? '#1E87A1'
                        : '',
                    overflow: 'hidden',
                  }}
                />
              ) : (
                <Popover
                  arrow={false}
                  content={
                    <ul>
                      <li>
                        {dayjs(item2['full_day'])
                          .format('LLLL')
                          .replace('12:00 AM', '')}
                      </li>
                      <li>{item['user_name']}</li>
                      <li>'{item2['type_name'][1]}'</li>
                      <li
                        style={{
                          textTransform: 'capitalize',
                        }}
                      >
                        {item2['start_date']}-{item2['end_date'][1]}(
                        {item2['time_range'][1]}d){' '}
                        {!Array.isArray(item2['status']) &&
                          String(item2['status'][1])?.replaceAll('_', ' ')}
                      </li>
                    </ul>
                  }
                  placement="bottomLeft"
                >
                  <div
                    className="has-text-centered pt-2"
                    style={{
                      width: '50%',
                      height: 40,
                      background:
                        item2['status'][1] === 'to_be_approved'
                          ? '#ffef5f'
                          : item2['color'][1],
                      color: item2['text_color'][1],
                      overflow: 'hidden',
                    }}
                    onMouseEnter={() => {
                      setMouseHover({
                        row: index2,
                        column: item?.id,
                      });
                    }}
                    onMouseLeave={() => {
                      setMouseHover(null);
                    }}
                  >
                    {item2['code'][1]}
                  </div>
                </Popover>
              )}
              {item2['type_name'][0] === null ? (
                <div
                  className="has-text-centered pt-2"
                  style={{
                    width: '50%',
                    height: 40,
                    background:
                      item2['status'][0] === 'to_be_approved'
                        ? '#ffef5f'
                        : item2['color'][0] === null
                        ? '#1E87A1'
                        : '',
                    overflow: 'hidden',
                  }}
                />
              ) : (
                <Popover
                  placement={'bottomLeft'}
                  arrow={false}
                  content={
                    <ul>
                      <li>
                        {dayjs(item2['full_day'])
                          .format('LLLL')
                          .replace('12:00 AM', '')}
                      </li>
                      <li>{item['user_name']}</li>
                      <li>'{item2['type_name'][0]}'</li>
                      <li
                        style={{
                          textTransform: 'capitalize',
                        }}
                      >
                        {item2['start_date']}-{item2['end_date'][0]}(
                        {item2['time_range'][0]}d){' '}
                        {!Array.isArray(item2['status']) &&
                          String(item2['status'][1])?.replaceAll('_', ' ')}
                      </li>
                    </ul>
                  }
                >
                  <div
                    className="has-text-centered pt-2"
                    style={{
                      width: '50%',
                      height: 40,
                      background:
                        item2['status'][0] === 'to_be_approved'
                          ? '#ffef5f'
                          : item2['color'][0],
                      color: item2['text_color'][0],
                      overflow: 'hidden',
                    }}
                    onMouseEnter={() => {
                      setMouseHover({
                        row: index2,
                        column: item?.id,
                      });
                    }}
                    onMouseLeave={() => {
                      setMouseHover(null);
                    }}
                  >
                    {item2['code'][0]}
                  </div>
                </Popover>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default TwoSide;
